import { Map } from 'immutable';

import {
    ASSET_LOAD_START,
    ASSET_LOAD_SUCCESS,
    ASSET_LOAD_FAIL,
    ASSET_LOAD_RELOAD,
    ASSET_LOAD_ABORT,
    ASSET_LOAD_END,
} from './actions';
import { keyForAsset } from './assets';

export const ASSET_STATUSES_KEY = 'assetStatuses';

const LOADING = 1;
const LOADED = 2;
const NOT_LOADED = 3;
const CANCELLED = 4;
export const AssetStatus = { LOADING, LOADED, NOT_LOADED, CANCELLED };

export const ASSET_TYPE = {
    IMAGE: 'image',
    VIDEO: 'video',
    POSTER: 'poster',
    TUTORIAL_VIDEO: 'tutorial_video',
    TUTORIAL_VIDEO_POSTER: 'tutorial_poster',
    INDY_TOPIC_KEY_SKILL_VIDEO: 'indy_topic_key_skill_video',
    INDY_TOPIC_KEY_SKILL_VIDEO_POSTER: 'indy_topic_key_skill_poster',
};

export const MAX_ATTEMPTS_BY_TYPE = {
    [ASSET_TYPE.IMAGE]: 1,
    [ASSET_TYPE.VIDEO]: 1,
    [ASSET_TYPE.POSTER]: 1,
    [ASSET_TYPE.TUTORIAL_VIDEO]: 1,
    [ASSET_TYPE.TUTORIAL_VIDEO_POSTER]: 1,
};

const initialEntry = Map({
    status: LOADING,
    currentAttempt: 1,
    failedAttempts: 0,
});

/**
 * The state for each asset consists of three parts, which this reducer handles.
 *
 * 1) 'status':
 *      Assets go through a life cycle when they try and load:
 *       - ASSET_LOAD_START
 *       - ASSET_LOAD_SUCCESS
 *       - ASSET_LOAD_END
 *
 *      or if unsuccessful:
 *       - ASSET_LOAD_START
 *       - ASSET_LOAD_FAIL
 *       - ASSET_LOAD_RELOAD
 *       ... (repeat FAIL and RELOAD)
 *       - ASSET_LOAD_ABORT
 *       - ASSET_LOAD_END
 *
 * 2) 'currentAttempt':
 *      This is the current load attempt number for the asset. Incrementing this
 *      value causes the asset to be remounted and reload.
 *
 * 3) 'failedAttempts':
 *      This is the number of times we have failed to load the asset. It is used
 *      to determine whether or not we should attempt to reload.
 */
export const assetStatusesReducer = (state = Map(), action) => {
    const { assetId, assetType, preload } = action;
    let key;
    let entry;
    switch (action.type) {
        case ASSET_LOAD_START:
            key = keyForAsset(assetId, assetType, preload);
            entry = state.get(key, initialEntry);
            if (
                entry.get('status') === AssetStatus.NOT_LOADED ||
                entry.get('status') === AssetStatus.CANCELLED
            ) {
                return state.set(key, initialEntry);
            } else {
                return state.set(key, entry);
            }

        case ASSET_LOAD_SUCCESS:
            key = keyForAsset(assetId, assetType, preload);
            entry = state.get(key, initialEntry);
            entry = entry.set('status', LOADED);
            return state.set(key, entry);

        case ASSET_LOAD_FAIL:
            key = keyForAsset(assetId, assetType, preload);
            entry = state.get(key, initialEntry);
            entry = entry.update('failedAttempts', attempts => attempts + 1);
            return state.set(key, entry);

        case ASSET_LOAD_RELOAD:
            key = keyForAsset(assetId, assetType, preload);
            entry = state.get(key, initialEntry);
            entry = entry.set('status', LOADING);
            entry = entry.set('currentAttempt', entry.get('failedAttempts') + 1);
            return state.set(key, entry);

        case ASSET_LOAD_ABORT:
            key = keyForAsset(assetId, assetType, preload);
            entry = state.get(key, initialEntry);
            entry = entry.set('status', NOT_LOADED);
            return state.set(key, entry);

        case ASSET_LOAD_END:
            key = keyForAsset(assetId, assetType, preload);
            entry = state.get(key, initialEntry);
            if (entry.get('status') === LOADING) {
                entry = entry.set('status', CANCELLED);
            }
            return state.set(key, entry);
    }

    return state;
};
